// extracted by mini-css-extract-plugin
export default {"text-label":"Labels__text-label___hhUsA","text-label-required":"Labels__text-label-required___jcciP","link-label":"Labels__link-label___RLM0d"};